import Immutable from 'immutable';
import * as actions from './actions';
import { STATUS } from './constants';

const defaultState = Immutable.fromJS({
  assemblages: {},
  courseProgress: {},
  classProgress: {},
  classDetail: {},
});

const emptyAssemblageData = Immutable.fromJS({
  node: {},
  course: {},
  content: {
    lessons: {},
    sections: {},
    exams: {},
  },
});

const emptyCourseProgressData = Immutable.fromJS({
  lessons: {},
  exams: {},
});

const emptyClassProgressData = Immutable.fromJS({
  lessons: {},
  exams: {},
});

const emptyClassDetailData = Immutable.fromJS({
  course_id: '',
  course_title: '',
  title: '',
  students: {},
});

export default (state = defaultState, action) => {
  switch (action.type) {
    case actions.LOAD_COURSE_ASSEMBLAGE_REQUEST:
      return state.getIn(['assemblages', `${action.payload.classId}`])
        ? state.updateIn(
            ['assemblages', `${action.payload.classId}`],
            (assemblage) =>
              assemblage
                .set('status', STATUS.RELOADING)
                .set('failureReason', '')
          )
        : state.update('assemblages', (assemblages) =>
            assemblages.set(
              `${action.payload.classId}`,
              Immutable.fromJS({
                status: STATUS.LOADING,
                failureReason: '',
                data: emptyAssemblageData,
              })
            )
          );

    case actions.LOAD_COURSE_ASSEMBLAGE_SUCCESS:
      return state.setIn(
        ['assemblages', `${action.payload.classId}`],
        Immutable.fromJS({
          status: STATUS.READY,
          failureReason: '',
          data: action.payload.assemblage,
        })
      );

    case actions.LOAD_COURSE_ASSEMBLAGE_FAILURE:
      return state.setIn(
        ['assemblages', `${action.payload.classId}`],
        Immutable.fromJS({
          status: STATUS.FAILURE,
          failureReason: action.payload.failureReason,
          data: emptyAssemblageData,
        })
      );

    case actions.LOAD_COURSE_PROGRESS_REQUEST:
      return state.getIn(['courseProgress', `${action.payload.classId}`])
        ? state.updateIn(
            ['courseProgress', `${action.payload.classId}`],
            (progress) => progress.set('status', STATUS.RELOADING)
          )
        : state.setIn(
            ['courseProgress', `${action.payload.classId}`],
            Immutable.fromJS({
              status: STATUS.LOADING,
              failureReason: '',
              data: emptyCourseProgressData,
            })
          );
    case actions.LOAD_COURSE_PROGRESS_SUCCESS:
      return state.setIn(
        ['courseProgress', `${action.payload.classId}`],
        Immutable.fromJS({
          status: STATUS.READY,
          failureReason: '',
          data: action.payload.data,
        })
      );
    case actions.LOAD_COURSE_PROGRESS_FAILURE:
      return state.setIn(
        ['courseProgress', `${action.payload.classId}`],
        Immutable.fromJS({
          status: STATUS.FAILURE,
          failureReason: action.payload.failureReason,
          data: emptyCourseProgressData,
        })
      );

    case actions.LOAD_CLASS_PROGRESS_REQUEST:
      return state.getIn(['classProgress', `${action.payload.classId}`])
        ? state.updateIn(
            ['classProgress', `${action.payload.classId}`],
            (progress) => progress.set('status', STATUS.RELOADING)
          )
        : state.setIn(
            ['classProgress', `${action.payload.classId}`],
            Immutable.fromJS({
              status: STATUS.LOADING,
              failureReason: '',
              data: emptyClassProgressData,
            })
          );
    case actions.LOAD_CLASS_PROGRESS_SUCCESS:
      return state.setIn(
        ['classProgress', `${action.payload.classId}`],
        Immutable.fromJS({
          status: STATUS.READY,
          failureReason: '',
          data: action.payload.data,
        })
      );
    case actions.LOAD_CLASS_PROGRESS_FAILURE:
      return state.setIn(
        ['classProgress', `${action.payload.classId}`],
        Immutable.fromJS({
          status: STATUS.FAILURE,
          failureReason: action.payload.failureReason,
          data: emptyCourseProgressData,
        })
      );
    case actions.SET_EXAM_LOCKED_REQUEST:
      return state.setIn(
        [
          'classProgress',
          `${action.payload.classId}`,
          'data',
          'exams',
          `${action.payload.examId}`,
          'is_locked',
        ],
        action.payload.isLocked
      );
    case actions.SET_EXAM_LOCKED_FAILURE:
      return state.setIn(
        [
          'classProgress',
          `${action.payload.classId}`,
          'data',
          'exams',
          `${action.payload.examId}`,
          'is_locked',
        ],
        !action.payload.isLocked
      );

    case actions.SET_LESSON_SELF_RATING_REQUEST:
      return state.setIn(
        [
          'courseProgress',
          `${action.payload.classId}`,
          'data',
          'lessons',
          `${action.payload.lessonId}`,
          'self_rating',
        ],
        action.payload.rating
      );
    case actions.SET_LESSON_SELF_RATING_FAILURE:
      return state.setIn(
        [
          'courseProgress',
          `${action.payload.classId}`,
          'data',
          'lessons',
          `${action.payload.lessonId}`,
          'self_rating',
        ],
        action.payload.currentRating
      );

    case actions.LOAD_CLASS_DETAIL_REQUEST:
      return state.getIn(['classDetail', `${action.payload.classId}`])
        ? state.updateIn(
            ['classDetail', `${action.payload.classId}`],
            (detail) => detail.set('status', STATUS.RELOADING)
          )
        : state.setIn(
            ['classDetail', `${action.payload.classId}`],
            Immutable.fromJS({
              status: STATUS.LOADING,
              failureReason: '',
              data: emptyClassDetailData,
            })
          );
    case actions.LOAD_CLASS_DETAIL_FAILURE:
      return state.setIn(
        ['classDetail', `${action.payload.classId}`],
        Immutable.fromJS({
          status: STATUS.FAILURE,
          failureReason: `${action.payload.failureReason}`,
          data: emptyClassDetailData,
        })
      );
    case actions.LOAD_CLASS_DETAIL_SUCCESS:
      return state.setIn(
        ['classDetail', `${action.payload.classId}`],
        Immutable.fromJS({
          status: STATUS.READY,
          failureReason: '',
          data: action.payload.data,
        })
      );

    default:
      return state;
  }
};
